import { environment } from '@/environments/environment';

function getDevApiBaseUrl(): string {
  return environment.apiBaseUrl;
}

export const AppConfig = {
  apiBaseUrl: getDevApiBaseUrl(),
};
